import axios from 'axios';
import { url } from 'configs/url';

const url_fetch = url.site;

const version = "v1";
let apiEnqueueSnackbar: any = null;
let isRedirectingToLogin = false;

export const setApiEnqueueSnackbar = (enqueueSnackbar) => {
    apiEnqueueSnackbar = enqueueSnackbar;
}

const generic_callback_error = (error) => { console.error(error)}

const getErrorUrl = (error) => {
    return error?.response?.config?.url || error?.config?.url || error?.url || "";
}

const isAuthSigninRequest = (error) => {
    return getErrorUrl(error).includes(`/api/${version}/${API.AUTH}/signin`);
}

const redirectToLogin = () => {
    if (isRedirectingToLogin || window.location.pathname === "/login") return;

    isRedirectingToLogin = true;
    window.location.href = "/login";
}

export const handleApiError = (error, callbackError, fallbackCallback = null, fallbackValue = undefined) => {
    const status = error?.response?.status || error?.status;

    if (status === 401 && !isAuthSigninRequest(error)) {
        if (typeof apiEnqueueSnackbar === "function") {
            apiEnqueueSnackbar("Votre session a expire. Veuillez vous reconnecter.", {
                variant: "error",
                key: "session-expired",
                preventDuplicate: true,
            });
        }

        if (fallbackCallback) {
            fallbackCallback(fallbackValue);
        }

        redirectToLogin();
        return true;
    }

    if (status === 403) {
        if (typeof apiEnqueueSnackbar === "function") {
            apiEnqueueSnackbar("Vous n'etes pas autorise à acceder à cette ressource.", {
                variant: "error",
                key: "access-denied",
                preventDuplicate: true,
            });
        }

        if (fallbackCallback) {
            fallbackCallback(fallbackValue);
        }
        return true;
    }

    callbackError(error);
    return false;
}

const parseJsonResponse = (response) => {
    if (response.status === 200) {
        return response.json();
    }

    return Promise.reject(response);
}

const parseAxiosData = (response) => {
    if (response.status === 200) {
        return response.data;
    }

    return Promise.reject(response);
}

const handleAxiosError = (callbackError) => {
    return (error) => {
        handleApiError(error, callbackError);
    }
}

const handleFetchError = (callbackError) => {
    return (error) => {
        handleApiError(error, callbackError);
    }
}

const handleForbiddenListError = (error, callback, callbackError) => {
    if (handleApiError(error, callbackError, callback, [])) {
        return;
    }

    callbackError(error);
}
// API To Call
export const API = {
	HARDWARE : "hardware",
	GROUP_HARDWARE : "hardwareGroup",
	UPLOAD : "upload",

	CONTENT : "content",
	MODULE : "module",
	VERSION : "version",
	VIDEO : "video",
	SURVEY : "survey",
	LICENCE : "licence",
	TOKEN : "token",
	REPORT : "report",

    LANG : "lang",

	ROLE : "role",
    PERMISSION : "permission",
	USER : "user",
	ENTERPRISE : "enterprise",
	AUTH : "auth",
    PCVR: "pcvr",
	SECURITY: "security",
}

// GET /api/{dataCall}/{action}/
export function actionGetAPI(dataCall, action, callback, callbackError = generic_callback_error) {
    fetch(url_fetch+'/api/'+version+"/"+dataCall+'/'+action+'/', { 
        method: 'GET'
    }).then(parseJsonResponse).then(dataBack => {
        callback(dataBack);
    }).catch(handleFetchError(callbackError));
}

// GET /api/{dataCall}/:id
export function getOneAPI(dataCall, id, callback, callbackError = generic_callback_error, params = null) {
    const url_params = params !== null ? "?" + new URLSearchParams(params).toString() : "";
    axios.get(url_fetch+'/api/'+version+"/"+dataCall+'/'+id+url_params)
        .then(res => { 
            callback(res.data) 
        }).catch(error => {
            handleApiError(error, callbackError);
        });
}

export function getOneActionAPI(dataCall, action, id, callback, callbackError = generic_callback_error, params = null, source = null) {
    const url_params = params !== null ? "?" + new URLSearchParams(params).toString() : "";
    axios.get(url_fetch+'/api/'+version+"/"+dataCall+'/'+action+"/"+id+url_params, source !== null ? {cancelToken: source.token} : null)
        .then(res => { 
            callback(res.data) 
        }).catch(error => {
            handleApiError(error, callbackError);
        });
}

// GET /api/{dataCall}/
export function getAllAPI(dataCall, callback, callbackError = generic_callback_error, params = null, source = null) {
    const url_params = params !== null ? "?" + new URLSearchParams(params).toString() : "";
    axios.get(url_fetch+'/api/'+version+"/"+dataCall+'/'+url_params, source !== null ? {cancelToken: source.token} : null)
        .then(res => {
            callback(res.data); 
        }).catch(error => {
            handleForbiddenListError(error, callback, callbackError);
        });
}

// POST /api/{dataCall}/
export function createAPI(dataCall, data, callback, callbackError = generic_callback_error) {
    fetch(url_fetch + '/api/' + version + "/" + dataCall + '/', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
    })
    .then(parseJsonResponse)
    .then(dataBack => {
        callback(dataBack);
    })
    .catch(handleFetchError(callbackError));
}

/**
 * POST /api/{dataCall}/{id}/{action} — une action nommée sur une ressource.
 *
 * Même voie que `createAPI`, mêmes en-têtes et même traitement d'erreur : la duplication sur
 * refus de modification majeure doit se comporter comme le reste, notamment vis-à-vis des
 * sessions expirées.
 */
export function actionAPI(dataCall, id, action, data, callback, callbackError = generic_callback_error) {
    fetch(url_fetch + '/api/' + version + "/" + dataCall + '/' + id + '/' + action, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
    })
    .then(parseJsonResponse)
    .then(dataBack => {
        callback(dataBack);
    })
    .catch(handleFetchError(callbackError));
}

// PUT /api/{dataCall}/
export function updateAPI(dataCall, id, data, callback, callbackError = generic_callback_error) {
    // console.log(`${url_fetch}/api/${version}/${dataCall}/${id}`);
    axios.put(`${url_fetch}/api/${version}/${dataCall}/${id}`, data, {
        headers: { 'Content-Type': 'application/json' }
    }).then(parseAxiosData)
    .then(callback)
    .catch(handleAxiosError(callbackError));
}

// DELETE /api/{dataCall}/
export function deleteAPI(dataCall, id, callback, callbackError = generic_callback_error) {
    fetch(url_fetch+'/api/'+version+"/"+dataCall+'/'+id, {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'}
    }).then(parseJsonResponse).then(data => {
        callback(data);
    }).catch(handleFetchError(callbackError));
}


// POST /api/{dataCall}/{action}/
export function actionPostAPI(dataCall, action, data, callback, callbackError = generic_callback_error) {
    // console.log(`${url_fetch}/api/${version}/${dataCall}/${action}/`);
    axios.post(`${url_fetch}/api/${version}/${dataCall}/${action}/`, JSON.stringify(data), {
        headers: { 'Content-Type': 'application/json' }
    }).then(parseAxiosData)
    .then(callback)
    .catch(handleAxiosError(callbackError));
}

// PUT /api/{dataCall}/{action}/
export function actionPutAPI(dataCall, action, data, callback, callbackError = generic_callback_error) {
    fetch(url_fetch+'/api/'+version+"/"+dataCall+'/'+action+'/', { 
        method: 'PUT',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
    }).then(parseJsonResponse).then(dataBack => {
        callback(dataBack);
    }).catch(handleFetchError(callbackError));
}

// PATCH /api/{dataCall}/{action}/
export function actionPatchAPI(dataCall, action, data, callback, callbackError = generic_callback_error) {
    fetch(url_fetch+'/api/'+version+"/"+dataCall+'/'+action+'/', {
        method: 'PATCH',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
    }).then(parseJsonResponse).then(dataBack => {
        callback(dataBack);
    }).catch(handleFetchError(callbackError));
}

// Delete /api/{dataCall}/{action}/
export function actionDeleteAPI(dataCall, action, callback, callbackError = generic_callback_error) {
    axios.delete(`${url_fetch}/api/${version}/${dataCall}/${action}/`)
    .then(response => {
        callback(response);
    }).catch(handleAxiosError(callbackError));
}

// POST /api/v1/upload/
export function actionUploadImage(file, callbackProgress, callback, callbackError = generic_callback_error) {
    const formData = new FormData();
    formData.append('file', file);
    axios.post(url_fetch+'/api/'+version+"/"+API.UPLOAD+'/', formData, {
        onUploadProgress : callbackProgress
    }).then(res => {
        if (res.status === 200) {
            return res.data;
        } else {
            console.error(res);
        }
    }).then(dataBack => {
        callback(dataBack);
    }).catch(handleAxiosError(callbackError))
}

// POST /api/v1/upload/video
export function actionUploadVideo(file, callbackProgress, callback, callbackError = generic_callback_error) {
    const formData = new FormData();        
    formData.append('file', file);
    axios.post(url_fetch+'/api/'+version+"/"+API.UPLOAD+'/video', formData, {
        onUploadProgress : callbackProgress
    }).then(res => {
        if (res.status === 200) {
            return res.data;
        } else {
            console.error(res);
        }
    }).then(dataBack => {
        callback(dataBack);
    }).catch(handleAxiosError(callbackError))
}

// POST /api/v1/upload/srt
export function actionUploadSrt(file, callbackProgress, callback, callbackError = generic_callback_error) {
    const formData = new FormData();        
    formData.append('file', file);
    axios.post(url_fetch+'/api/'+version+"/"+API.UPLOAD+'/srt', formData, {
        onUploadProgress : callbackProgress
    }).then(res => {
        if (res.status === 200) {
            return res.data;
        } else {
            console.error(res);
        }
    }).then(dataBack => {
        callback(dataBack);
    }).catch(handleAxiosError(callbackError))
}

// POST /api/v1/upload/image360
export function actionUploadImage360(file, callbackProgress, callback, callbackError = generic_callback_error) {
    const formData = new FormData();        
    formData.append('file', file);
    axios.post(url_fetch+'/api/'+version+"/"+API.UPLOAD+'/image360', formData, {
        onUploadProgress : callbackProgress
    }).then(res => {
        if (res.status === 200) {
            return res.data;
        } else {
            console.error(res);
        }
    }).then(dataBack => {
        callback(dataBack);
    }).catch(handleAxiosError(callbackError))
}

// POST /api/v1/upload/sound
export function actionUploadSound(file, callbackProgress, callback, callbackError = generic_callback_error) {
    const formData = new FormData();        
    formData.append('file', file);
    axios.post(url_fetch+'/api/'+version+"/"+API.UPLOAD+'/sound', formData, {
        onUploadProgress : callbackProgress
    }).then(res => {
        if (res.status === 200) {
            return res.data;
        } else {
            console.error(res);
        }
    }).then(dataBack => {
        callback(dataBack);
    }).catch(handleAxiosError(callbackError))
}

//PCVR

//GET /api/v1/pcvr/getPcvrByLicence/{licenceId}
export function listPcvrsByLicence(
  licenceId: string,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = {};
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;
  axios
    .get(`${url_fetch}/api/${version}/${API.PCVR}/getPcvrByLicence/${licenceId}`, cfg)
    .then((result) => callback(result.data))
    .catch(handleAxiosError(callbackError));
}

export function checkPcvrVersion(
    versionId: string,
    callback: (data: any[]) => void,
    callbackError = generic_callback_error,
    params: any = null,
    source: any = null
) {
    const cfg: any = {};
    if (params) cfg.params = params;
    if (source?.token) cfg.cancelToken = source.token;
    axios
        .get(`${url_fetch}/api/${version}/${API.PCVR}/checkPcvrVersion/${versionId}`, cfg)
        .then((r) => callback(r.data))
        .catch(handleAxiosError(callbackError));
}

// PUT /api/v1/pcvr
export function createPcvrViaPut(
  payload: any,
  callback: (data: any) => void,
  callbackError = generic_callback_error
) {
  axios
    .put(`${url_fetch}/api/${version}/${API.PCVR}`, payload)
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// PATCH /api/v1/pcvr/:uuid
export function updatePcvr(
  uuid: string,
  body: any,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = {};
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;
  axios
    .patch(`${url_fetch}/api/${version}/${API.PCVR}/${uuid}/`, body, cfg)
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// PATCH /api/v1/pcvr/:uuid
export function archivePcvr(
  uuid: string,
  archived: boolean,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = {};
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;

  axios
    .patch(`${url_fetch}/api/${version}/${API.PCVR}/${uuid}/archive`, { archived })
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

//   pcvrClientManaged //

// GET /api/v1/pcvrClientManaged/:id
export function getClientManagedPcvr(
  licenceId: string,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = {};
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;

  axios
    .get(`${url_fetch}/api/${version}/pcvrClientManaged/${licenceId}`, cfg)
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// PUT /api/v1/pcvrClientManaged/:id  (body: { enabled: boolean })
export function setClientManagedPcvr(
  licenceId: string,
  enabled: boolean,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = { headers: { "Content-Type": "application/json" } };
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;

  axios
    .put(`${url_fetch}/api/${version}/pcvrClientManaged/${licenceId}`, { enabled }, cfg)
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// GET /api/v1/pcvr/getTokenUsage/:uuid
export function getPcvrTokenUsage(
  uuid: string,
  callback: (data: any) => void,
  callbackError = generic_callback_error,
  params: any = null,
  source: any = null
) {
  const cfg: any = { headers: { "Content-Type": "application/json" } };
  if (params) cfg.params = params;
  if (source?.token) cfg.cancelToken = source.token;

  axios
    .get(`${url_fetch}/api/${version}/${API.PCVR}/getTokenUsage/${uuid}`, cfg)
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// GET /api/v1/token/consumed/hardware/tokens_stats
export function getHardwareTokenStats(
  hardwareIds: string[],
  callback: (rows: any) => void,
  callbackError = generic_callback_error,
  opts: { startDate?: string; endDate?: string } = {},
  source: any = null
) {
  const cfg: any = { headers: { "Content-Type": "application/json" } };
  if (source?.token) cfg.cancelToken = source.token;
  axios
    .post(
      `${url_fetch}/api/${version}/${API.TOKEN}/consumed/hardware/tokens_stats`,
      { hardwareIds, ...opts },
      cfg
    )
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}

// GET /api/v1/token/consumed/hardware/used_stats
export function getHardwareUsedStats(
  hardwareIds: string[],
  callback: (rows: any) => void,
  callbackError = generic_callback_error,
  opts: { startDate?: string; endDate?: string } = {},
  source: any = null
) {
  const cfg: any = { headers: { "Content-Type": "application/json" } };
  if (source?.token) cfg.cancelToken = source.token;
  axios
    .post(
      `${url_fetch}/api/${version}/${API.TOKEN}/consumed/hardware/used_stats`,
      { hardwareIds, ...opts },
      cfg
    )
    .then((r) => callback(r.data))
    .catch(handleAxiosError(callbackError));
}
